(function () {
  'use strict';

  var ROOT_ID = 'tcb-pdp-reviews';

  function rootEl() {
    return document.getElementById(ROOT_ID);
  }

  function loadWidgets() {
    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
      window.jdgm.loadWidgets();
    }
  }

  function widgetEl(scope) {
    return scope.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
  }

  function reviewData(scope) {
    var widget = widgetEl(scope);
    if (!widget) return null;
    var id = widget.getAttribute('data-id') || widget.getAttribute('data-product-id');
    if (!id || !window.jdgm || !window.jdgm.data || !window.jdgm.data.reviewWidget) return null;
    return window.jdgm.data.reviewWidget[id] || null;
  }

  function writeButtons(scope) {
    var nodes = scope.querySelectorAll(
      '.jdgm-write-rev-link, .jdgm-btn--write-review, a.jdgm-write-rev-link, button.jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link, .jm-action-buttons__button, .jm-button--primary'
    );
    return Array.prototype.filter.call(nodes, function (btn) {
      return /write\s*a?\s*review/i.test(btn.textContent || '');
    });
  }

  function openWriteReview(scope) {
    var slot = scope.querySelector('[data-tcb-reviews-write-slot]');
    if (slot) {
      var moved = slot.querySelector('.jdgm-write-rev-link, .jdgm-btn--write-review, .jm-action-buttons__button, .jm-button--primary');
      if (moved) {
        moved.click();
        return true;
      }
    }

    var widget = widgetEl(scope);
    var id = widget && (widget.getAttribute('data-id') || widget.getAttribute('data-product-id'));
    if (window.jdgm) {
      if (typeof window.jdgm.openWriteReviewForm === 'function' && id) {
        window.jdgm.openWriteReviewForm(id);
        return true;
      }
      if (typeof window.jdgm.openReviewForm === 'function' && id) {
        window.jdgm.openReviewForm(id);
        return true;
      }
    }

    var hidden = scope.querySelector('.tcb-reviews-v2__widget .jdgm-write-rev-link, .tcb-reviews-v2__widget .jm-action-buttons__button, .tcb-reviews-v2__widget .jm-button--primary');
    if (hidden) {
      hidden.style.setProperty('display', 'inline-flex', 'important');
      hidden.click();
      hidden.style.removeProperty('display');
      return true;
    }

    loadWidgets();
    return false;
  }

  function moveWriteButton(scope) {
    var slot = scope.querySelector('[data-tcb-reviews-write-slot]');
    if (!slot) return;

    var buttons = writeButtons(scope);
    var fallback = slot.querySelector('[data-tcb-reviews-write-fallback]');
    var primary = null;

    buttons.forEach(function (btn) {
      if (!primary) {
        primary = btn;
        return;
      }
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('tabindex', '-1');
      btn.classList.add('tcb-reviews-v2__write-hidden');
    });

    if (primary && primary.tagName === 'A' && primary.getAttribute('href') === '#') {
      primary.setAttribute('href', '#tcb-pdp-reviews');
      primary.setAttribute('role', 'button');
      primary.addEventListener('click', function (e) {
        e.preventDefault();
      });
    }

    if (primary && !slot.contains(primary)) {
      primary.classList.add('tcb-reviews-v2__write-btn');
      primary.removeAttribute('aria-hidden');
      primary.removeAttribute('tabindex');
      slot.appendChild(primary);
      if (fallback) fallback.hidden = true;
      return;
    }

    if (primary && slot.contains(primary)) {
      if (primary.tagName === 'A' && primary.getAttribute('href') === '#') {
        primary.setAttribute('href', '#tcb-pdp-reviews');
        primary.setAttribute('role', 'button');
      }
      if (fallback) fallback.hidden = true;
      return;
    }

    if (!fallback || fallback.dataset.bound) return;
    fallback.dataset.bound = '1';
    fallback.hidden = false;
    fallback.addEventListener('click', function () {
      if (!openWriteReview(scope)) {
        setTimeout(function () {
          moveWriteButton(scope);
          openWriteReview(scope);
        }, 500);
      }
    });
  }

  function enhanceSummary(scope) {
    var summary = scope.querySelector('.jdgm-rev-widg__summary');
    var data = reviewData(scope);
    var count = data && data.number_of_reviews ? data.number_of_reviews : 0;

    if (count <= 0) {
      scope.classList.add('tcb-reviews-v2--empty');
      if (!scope.querySelector('[data-tcb-reviews-empty]')) {
        var empty = document.createElement('div');
        empty.className = 'tcb-reviews-v2__empty';
        empty.setAttribute('data-tcb-reviews-empty', '');
        empty.innerHTML =
          '<p class="tcb-reviews-v2__empty-title">No reviews yet</p>' +
          '<p class="tcb-reviews-v2__empty-copy">Be the first professional to share feedback on this model after purchase.</p>';
        var mount = scope.querySelector('.tcb-reviews-v2__widget');
        if (mount) mount.insertBefore(empty, mount.firstChild);
      }
      return;
    }

    scope.classList.remove('tcb-reviews-v2--empty');
    var emptyState = scope.querySelector('[data-tcb-reviews-empty]');
    if (emptyState) emptyState.remove();

    if (!summary) return;

    var summaryText = summary.querySelector('.jdgm-rev-widg__summary-text');
    if (summaryText && !summary.querySelector('[data-tcb-verified-count]')) {
      var data = reviewData(scope);
      var count = data && data.number_of_reviews ? data.number_of_reviews : 0;
      if (count > 0) {
        var verified = document.createElement('p');
        verified.className = 'tcb-reviews-v2__verified-count';
        verified.setAttribute('data-tcb-verified-count', '');
        verified.textContent = count + ' verified review' + (count === 1 ? '' : 's');
        summaryText.insertAdjacentElement('afterend', verified);
      }
    }

    if (!summary.querySelector('[data-tcb-verified-badge]')) {
      var pill = document.createElement('p');
      pill.className = 'tcb-reviews-v2__verified-pill';
      pill.setAttribute('data-tcb-verified-badge', '');
      pill.innerHTML =
        '<span class="tcb-reviews-v2__verified-icon" aria-hidden="true">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v5c0 5-3 9-7 10C8 20 5 16 5 11V6l7-3z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>' +
        '</span> Verified commercial buyers';
      summary.appendChild(pill);
    }
  }

  function wrapSummaryHeader(scope) {
    var header = scope.querySelector('.jdgm-rev-widg__header');
    if (header && !header.classList.contains('tcb-reviews-v2__summary-box')) {
      header.classList.add('tcb-reviews-v2__summary-box');
    }
  }

  function layoutReviewCards(scope) {
    scope.querySelectorAll('.jdgm-rev').forEach(function (rev) {
      if (rev.dataset.tcbLayout === '1') return;
      rev.dataset.tcbLayout = '1';

      var header = rev.querySelector('.jdgm-rev__header');
      var badge = rev.querySelector('.jdgm-rev__buyer-badge');
      var timestamp = rev.querySelector('.jdgm-rev__timestamp');

      if (header) {
        if (badge && badge.parentElement !== header) header.appendChild(badge);
        if (timestamp && timestamp.parentElement !== header) header.appendChild(timestamp);
      }

      if (rev.querySelector('.tcb-rev-grid')) return;

      var icon = rev.querySelector('.jdgm-rev__icon');
      var authorWrap = rev.querySelector('.jdgm-rev__author-wrapper') || rev.querySelector('.jdgm-rev__author');
      var title = rev.querySelector('.jdgm-rev__title');
      var body = rev.querySelector('.jdgm-rev__body');
      if (!authorWrap && !body) return;

      var grid = document.createElement('div');
      grid.className = 'tcb-rev-grid';

      var left = document.createElement('div');
      left.className = 'tcb-rev-grid__left';
      var right = document.createElement('div');
      right.className = 'tcb-rev-grid__right';

      if (icon) left.appendChild(icon);
      if (authorWrap) left.appendChild(authorWrap);

      if (title) right.appendChild(title);
      if (body) right.appendChild(body);

      grid.appendChild(left);
      grid.appendChild(right);

      var anchor = rev.querySelector('.jdgm-rev__header');
      if (anchor && anchor.nextSibling) {
        rev.insertBefore(grid, anchor.nextSibling);
      } else {
        rev.appendChild(grid);
      }
    });
  }

  function enhance(scope) {
    if (!scope) return;
    wrapSummaryHeader(scope);
    moveWriteButton(scope);
    enhanceSummary(scope);
    layoutReviewCards(scope);
    scope.classList.add('tcb-reviews-v2--ready');
  }

  function scheduleEnhance(scope) {
    [120, 400, 900, 1800, 3200, 6000].forEach(function (ms) {
      setTimeout(function () {
        enhance(scope);
      }, ms);
    });
  }

  function bindAccordion(scope) {
    if (!scope || scope.dataset.tcbReviewsBound === '1') return;
    scope.dataset.tcbReviewsBound = '1';

    scope.addEventListener('toggle', function () {
      if (!scope.open) return;
      loadWidgets();
      scheduleEnhance(scope);
    });

    if (scope.open) {
      loadWidgets();
      scheduleEnhance(scope);
    }
  }

  function observe(scope) {
    var mount = scope.querySelector('.tcb-reviews-v2__widget');
    if (!mount || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      enhance(scope);
    });

    observer.observe(mount, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 45000);
  }

  function init() {
    var scope = rootEl();
    if (!scope) return;

    bindAccordion(scope);
    observe(scope);
    loadWidgets();
    scheduleEnhance(scope);
    openFromHash();
    syncPreviewRating();
    [400, 1200, 3000].forEach(function (ms) {
      setTimeout(syncPreviewRating, ms);
    });
  }

  function openFromHash() {
    var hash = window.location.hash;
    if (!hash) return;
    var target = document.querySelector(hash);
    if (!target) return;
    var acc = target.matches('[data-tcb-pdp-acc]') ? target : target.closest('[data-tcb-pdp-acc]');
    if (acc) acc.open = true;
    if (hash === '#tcb-pdp-reviews') {
      loadWidgets();
      scheduleEnhance(acc || target);
    }
    window.setTimeout(function () {
      var nav = document.querySelector('[data-tcb-section-nav]');
      var navH = nav ? nav.offsetHeight : 0;
      var y = target.getBoundingClientRect().top + window.scrollY - navH - 72;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }, 120);
  }

  function syncPreviewRating() {
    var preview = document.getElementById('tcb-review-preview');
    var widget = widgetEl(document);
    if (!preview || !widget) return;
    var id = widget.getAttribute('data-id') || widget.getAttribute('data-product-id');
    if (!id || !window.jdgm || !window.jdgm.data || !window.jdgm.data.reviewWidget) return;
    var data = window.jdgm.data.reviewWidget[id];
    if (!data) return;

    var count = parseInt(data.number_of_reviews, 10) || 0;
    var avg = parseFloat(data.average_rating) || 0;
    var custom = preview.querySelector('.tcb-preview-rating');

    if (count <= 0 || avg <= 0) {
      if (custom) custom.style.display = 'none';
      return;
    }

    if (custom) {
      custom.style.display = '';
      var score = custom.querySelector('.tcb-preview-score');
      var countEl = custom.querySelector('.tcb-preview-count');
      if (score) score.textContent = avg.toFixed(1);
      if (countEl) countEl.textContent = count + ' review' + (count === 1 ? '' : 's');
      custom.setAttribute('aria-label', avg.toFixed(1) + ' out of 5 stars, ' + count + ' reviews');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
